import { render, staticRenderFns } from "./BloqueImagen.vue?vue&type=template&id=a182853e&scoped=true"
import script from "./BloqueImagen.vue?vue&type=script&lang=js"
export * from "./BloqueImagen.vue?vue&type=script&lang=js"
import style0 from "./BloqueImagen.vue?vue&type=style&index=0&id=a182853e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a182853e",
  null
  
)

export default component.exports